export default class Extra {
    constructor(props) {
        Object.assign(this, props);
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/Extras/Extra.ts
// module id = 361
// module chunks = 0